<template>
  <v-dialog v-model="newExpedienteDialog" max-width="600px">
    <v-btn
      v-if="!externalActivator"
      slot="activator"
      color="primary"
      dark
      class="mb-2"
    >
      Nuevo Expediente
    </v-btn>
    <v-card v-if="nuevoExpediente">
      <v-card-title>
        <div>
          <div class="headline">Crear un Nuevo Expediente</div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1"
              >Catastro</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step
              :complete="e1 > 2"
              :rules="[() => isOkData]"
              step="2"
              >Datos</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step step="3">Gestión</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4">Terminado</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-5" color="white" height="200px">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-checkbox
                        v-model="sinCatastro"
                        value="1"
                        label="Sin Referencia Catastral"
                        type="checkbox"
                      >
                      </v-checkbox>
                      <v-btn
                        :class="temaColor"
                        @click="subirArchivosCatastro = true"
                      >
                        Archivo
                      </v-btn>
                      <v-flex xs12 v-if="!sinCatastro">
                        <v-text-field
                          v-model="searchCatastro"
                          mask="NNNNNNNNNNNNNN"
                          append-icon="search"
                          label="Referencia Catastral"
                          maxlength="14"
                          counter="14"
                          @click:clear="resetBox"
                          v-on:keyup.13="buscarReferencia"
                          clearable
                          single-line
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
              <v-btn
                :disabled="searchCatastro.length < 14 && !sinCatastro"
                color="primary"
                @click.stop="buscarReferencia"
              >
                Siguiente
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mb-5"
                :color="isOkData ? '' : 'grey lighten-1'"
                height="300px"
              >
                <v-card-text>
                  <v-layout wrap v-if="!isOkData">
                    <v-flex
                      xs12
                      class="text-xs-center grey--text text--darken-1"
                    >
                      <!-- Ref.: 4524601TG3442D / {{ creteNewExpediente().code }} -->
                      <span
                        :class="
                          isOkData
                            ? 'light-blue--text text--darken-1'
                            : 'red--text text--darken-1'
                        "
                        >Ref.: {{ dataResult.ref }} /
                        {{ dataResult.code }}</span
                      ><br />
                      <span>{{ dataResult.direc1 }}</span
                      ><br />
                      <span>{{ dataResult.direc2 }}</span
                      ><br />
                      <span>{{ dataResult.comunidad }}</span
                      ><br />
                      <span>({{ dataResult.inmuebles }} Inmuebles)</span><br />
                      <span class="red--text text--darken-1"
                        ><b>{{ mensajeError }}</b></span
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-else>
                    <v-flex xs12>
                      <v-text-field
                        :disabled="buscando"
                        label="Nombre de la Comunidad de Propietarios"
                        v-model="nuevoExpediente.nombreComunidad"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        :disabled="buscando"
                        v-model="eligeComunidad"
                        :items="comunidades"
                        :filter="customFilter"
                        item-text="comunidadName"
                        label="Comunidad Autónoma"
                        @change="changeComunidad"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 v-if="nuevoExpediente.ca.code">
                      <v-autocomplete
                        :disabled="buscando"
                        v-model="nuevoExpediente.provincia"
                        :items="filterProvincia"
                        :filter="customFilter"
                        item-text="text"
                        label="Provincia"
                        @change="changeProvincia"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 v-if="nuevoExpediente.provincia">
                      <v-autocomplete
                        :disabled="buscando"
                        v-model="nuevoExpediente.localidad"
                        :items="municipioSelect"
                        :filter="customFilter"
                        item-text="text"
                        label="Localidad"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 v-if="buscando">
                      <v-progress-linear
                        indeterminate
                        color="blue"
                        class="mb-0"
                      >
                      </v-progress-linear>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-btn
                :disabled="!isOkData || !checkGuardarExpediente || buscando"
                color="primary"
                @click.stop="guardarResultados"
              >
                Guardar
              </v-btn>

              <v-btn :disabled="buscando" flat @click="resetBox">Atrás</v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-5" color="white" height="290px">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-autocomplete
                          prepend-icon="person"
                          v-model="gestor"
                          :items="gestores"
                          item-text="name"
                          item-value="idx"
                          label="Gestor Responsable"
                          persistent-hint
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          prepend-icon="person"
                          v-model="administrador"
                          :items="adminfincas"
                          item-text="name"
                          item-value="idx"
                          label="Administrador de Fincas"
                          persistent-hint
                        >
                        </v-autocomplete>
                      </v-flex>
                      <!-- <template v-if="nuevoExpediente.refCatastro">
                                                <v-flex xs12 v-if="!fileCatastro">
                                                    <h2 class="blue--text  font-weight-light pb-2">¿ Incluir el archivo del catastro ?</h2>
                                                    <input accept="application/vnd.ms-excel, text/xml" class="font-weight-light" type="file" @change="onFileChange">
                                                </v-flex>
                                                <v-flex xs12 v-else>
                                                    <span>{{ fileCatastro.name }}</span>
                                                    <v-btn class="red white--text" @click="removeFile">Eliminar</v-btn>
                                                </v-flex>
                                            </template> -->
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-btn color="success" @click.stop="expedienteUpdate">
                Guardar
              </v-btn>

              <!-- <v-btn flat @click="e1 = 2">Atrás</v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="mb-5" color="white" height="200px">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        Expediente guardado con éxito
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-btn flat @click="closeWindows">Cerrar</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="closeWindows"
          >Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
    <admin-file-up
      :tema="temaColor"
      :openDialog="subirArchivosCatastro"
      v-on:resultado="asignarSearchCatastro"
      v-on:closeDialog="subirArchivosCatastro = false"
    >
    </admin-file-up>
  </v-dialog>
</template>

<script>
import AdminFileUp from "../admin-pages/admin-fileup.vue";
export default {
  props: ["externalActivator", "externalActived"],
  components: {
    AdminFileUp
  },
  data() {
    return {
      eligeComunidad: null,
      subirArchivosCatastro: false,
      e1: 0,
      sinCatastro: false,
      newExpedienteDialog: false,
      searchCatastro: "",
      buscando: false,
      isOkData: true,
      mensajeError: "",
      dataResult: {
        ref: "",
        code: "",
        direc1: "",
        direc2: "",
        comunidad: "",
        inmuebles: 0
      },
      administrador: false,
      gestor: "",
      fileCatastro: null,
      expedienteId: null,
      nuevoExpediente: null,
      eventPromiseError: null,
      eventPromiseEnd: null
    };
  },
  watch: {
    eventoNewExpediente(newValue) {
      if (newValue && this.buscando) {
        // this.evaluaEvento()
        // Ha ocurrido un error
        if (newValue.error) {
          this.evaluaEvento();
        }
        // El evento ha finalizado: Borrar evento
        if (newValue.finalizado && !this.eventPromiseEnd) {
          this.evaluaEvento();
          this.eventPromiseEnd = setTimeout(() => {
            this.$store.dispatch("setEventoLeido", "newExpediente");
            this.eventPromiseEnd = null;
            this.eventPromiseError = null;
          }, 5000);
          return;
        }
        // El evento ha sido suscrito por el BackEnd
        if (newValue.timeStart) {
          clearTimeout(this.eventPromiseError);
          this.eventPromiseError = null;
          return;
        }
      }
    },
    externalActived(newValue) {
      if (this.externalActivator) {
        this.newExpedienteDialog = newValue;
      }
    },
    newExpedienteDialog() {
      this.resetBox();
    },
    alertaCatastroStatus(newStatus, oldStatus) {
      if (newStatus && !oldStatus) {
        if (this.buscando) {
          this.leeResult();
        }
      }
    }
  },
  mounted: function() {
    this.gestor = this.uid;
    // this.setAlertaCatastro()
  },
  computed: {
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    filterProvincia() {
      if (!this.nuevoExpediente || this.nuevoExpediente.ca.idx < 0) {
        return [];
      }
      const provincias = this.comunidades[this.nuevoExpediente.ca.idx]
        .provincias;
      // const provincias = [4,11,14,18,21,23,29,41]
      return this.provinciaSelect.filter(
        item => !item.value || provincias.includes(parseInt(item.value))
      );
      // return this.provinciaSelect.filter(item => !item.value || parseInt(item.value).indexOf(provincias) > -1)
    },
    eventoNewExpediente() {
      if (this.eventosUser && this.eventosUser.newExpediente) {
        return this.eventosUser.newExpediente;
      }
      return false;
    },
    eventosUser() {
      return this.$store.getters.getEventosUser;
    },
    checkGuardarExpediente() {
      if (!this.nuevoExpediente) {
        return false;
      }
      let result =
        this.nuevoExpediente.provincia &&
        typeof this.nuevoExpediente.localidad === "number" &&
        this.nuevoExpediente.nombreComunidad;
      return result;
    },
    comunidades() {
      return this.$store.getters.getComunidades;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    expedienteModelo() {
      return this.$store.getters.getExpedienteModelo;
    },
    adminfincas() {
      return this.$store.getters.getAdminFincas; // getAdminFincas
    },
    gestores() {
      return this.$store.getters.getGestores;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    alertaCatastro() {
      return this.$store.getters.getAlertaCatastro;
    },
    alertaCatastroStatus() {
      return this.alertaCatastro ? this.alertaCatastro.encontrado : false;
    },
    alertaCatastroResult() {
      return this.alertaCatastro ? this.alertaCatastro.result : false;
    },
    alertaCatastroOcupadoPorOtro() {
      return this.alertaCatastro
        ? this.alertaCatastroStatus && !this.buscando
        : false;
    }
  },
  methods: {
    asignarSearchCatastro(e) {
      /* eslint-disable */
            console.log('recibo el evento...')
            console.log(e)
            this.searchCatastro = e.idx // $event
            this.nuevoExpediente.inmueblesNumber = e.numInmuebles
            this.nuevoExpediente.direccion = e.direccion
            this.sinCatastro = false
        },
        onFileChange(e) {
            const files = e.target.files || e.dataTransfer.files
            if (!files.length || files.length > 1) return
            this.fileCatastro = files[0]
        },
        removeFile() {
            this.fileCatastro = null;
        },
        onFileSubmit() {
            if (this.fileCatastro) {
                if (!this.fileCatastro.type.startsWith('application/vnd.ms-excel') && !this.fileCatastro.type.startsWith('text/xml')) {
                    alert(`El formato del archivo seleccionado no es válido.
                    Sólo se admiten archivos Excell del tipo XML.`)
                    return
                }
                // const time = Date.now()
                const filename = this.fileCatastro.name
                const userUid = this.uid
                const storageRef = this.$storage.ref()
                // const extensionFile = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || ''
                // const myStorage = storageRef.child(`${userUid}/${filename}`) // this.fileUp.name
                const myStorage = storageRef.child(`${userUid}/${filename}`)
                const meta = {
                    customMetadata: {
                        'originalName': filename,
                        'originalType': this.fileCatastro.type,
                        'client': userUid
                    }
                }
                myStorage.put(this.fileCatastro, meta)
                    .then(snapshot => {
                        // eslint-disable-next-line
                        console.log(snapshot)
                        /* this.virtualResult = snapshot
                        this.endSubmit()
                        myStorage.getDownloadURL().then(url => {
                            this.userDocuments.push({
                                description: this.filedescription,
                                url: url,
                                idx: false,
                                name: 'Guardando...'
                            })
                        }) */
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                        /* this.virtualResult = {
                            error: error
                        } */
                        // consoleLog('Error al subir archivo')
                        // consoleLog(error)
                    })


                // this.$store.dispatch('subirFileCatastro', this.fileCatastro)
            }
        },
        buscarComunidad(provincia) {
            /* return this.comunidades.filter(cdad => {
                return cdad.provincias.indexOf(parseInt(provincia)) > 1
            }) */
            let result = this.comunidades.map((cdad, i) => {
                return {
                    code: cdad.comunidadId,
                    name: cdad.comunidadName,
                    idx: i,
                    provincias: cdad.provincias
                }
            }).filter(comu => comu.provincias.find(element => element === parseInt(provincia)))[0]
            if (result) {
                delete result.provincias
            }
            return result
        },
        customFilter(item, queryText) { // , itemText
            const textOne = item.text.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
        },
        changeComunidad() {
            this.nuevoExpediente.provincia = null
            this.nuevoExpediente.ca = this.comunidades
                .map((it, i) => {
                    return {
                        code: it.comunidadId,
                        name: it.comunidadName,
                        idx: i
                    }
                })
                .filter(item => item.name === this.eligeComunidad)[0]
                /* .map((cd, i) => {
                    return {
                        code: cd.comunidadId,
                        name: cd.comunidadName,
                        idx: i
                    }
                })[0] */
            /* this.nuevoExpediente.ca = {
                code: cdad.comunidadId,
                name: cdad.comunidadName
            } */
        },
        changeProvincia() {
            // this.$emit('changeProvincia', this.usuario.direccion.provincia)
            this.nuevoExpediente.localidad = null
            if (this.nuevoExpediente.provincia) {
                this.$store.dispatch('setMunicipios', this.nuevoExpediente.provincia)    
            }
        },
        closeWindows() {
            this.nuevoExpediente = null
            if (this.externalActivator) {
                this.$emit('closeNew')
            } else {
                this.newExpedienteDialog = false
            }
        },
        setAlertaCatastro() {
            if (!this.alertaCatastro) {
                this.$store.dispatch('setAlertaCatastro');
            }
        },
        resetBox() {
            this.searchCatastro = ''
            this.buscando = false
            this.isOkData = true
            this.mensajeError = ''
            this.e1 = 1
            this.nuevoExpediente = null
            this.nuevoExpediente = this.expedienteModelo
            if (this.nuevoExpediente.provincia === '') {
                this.nuevoExpediente.provincia = null
            }
        },
        nextItem() {
            this.e1 += 1
        },
        buscarReferencia() {
            // "4524601TG3442D"
            if (this.searchCatastro.length !== 14 && !this.sinCatastro) {
                alert(`La referencia catastal debe contener 14 caracteres alfanuméricos.`)
                return
            }
            if (this.searchCatastro.length === 14) {
                // this.buscando = true
                // 1 - Busca en BD
                const catastroBd = this.$store.getters.getCatastroId(this.searchCatastro)
                if (catastroBd && catastroBd.expediente) {
                    // eslint-disable-next-line
                    console.log(`Esta referencia ya está asignada a otro expediente: ${catastroBd.expediente}`)
                    this.referenciaExistente(catastroBd)
                } else {
                    // 2 - Busca en Catastro
                    this.nuevoExpediente.refCatastro = this.searchCatastro
                }   
            }
            this.e1 += 1
        },
        referenciaExistente(datos) {
            let data = datos
            this.isOkData = false
            data.ca = {
                code: 'N/A',
                name: 'N/A'
            }
            data.inmueblesNumber = 'N/A'
            this.mensajeError = 'Esta referencia catastral ya está asignada a otro expediente'
            this.pintaResult(data)
        },
        pintaResult(result) {
            if (result) {
                this.dataResult = {
                    ref: result.catastro,
                    code: result.expediente,
                    direc1: `${result.datos.dir_viaTipo} ${result.datos.dir_viaName}, ${result.datos.dir_viaNumber}`,
                    direc2: `${result.datos.dir_cp} - ${result.datos.dir_localidadName}, ${result.datos.dir_provinciaName}`,
                    comunidad: `${result.ca.code} - ${result.ca.name}`,
                    inmuebles: result.inmueblesNumber
                }
                    
                this.buscando = false
                // this.e1 = 2
                // this.$store.dispatch('nuevaAlertaCatastro', false);
            }
        },
        leeResult() {
            this.isOkData = true
            // this.buscando = false
            this.pintaResult(this.alertaCatastroResult)
            /* const result = this.alertaCatastroResult
            if (result) {
                this.dataResult = {
                    ref: result.catastro,
                    code: result.expediente,
                    direc1: `${result.datos.dir_viaTipo} ${result.datos.dir_viaName}, ${result.datos.dir_viaNumber}`,
                    direc2: `${result.datos.dir_cp} - ${result.datos.dir_localidadName}, ${result.datos.dir_provinciaName}`,
                    comunidad: `${result.ca.code} - ${result.ca.name}`,
                    inmuebles: result.inmueblesNumber
                }
                this.buscando = false
                this.e1 = 2
            } */
        },
        evaluaEvento() {
            this.buscando = false
            const isError = this.eventoNewExpediente.error
            if (isError) {
                /* eslint-disable */
                console.log('Ha ocurrido un error:')
                console.log(this.eventoNewExpediente.error)
                // Acciones con error
            } else {
                // Acciones con éxito
                this.e1 += 1
            }
            /* eslint-disable */
            console.log(this.eventoNewExpediente.mensaje)
            console.log(this.eventoNewExpediente.data)
            
        },
        guardarResultados() {
            /* this.buscando = true
            // Preveer fallo de comunicación con el servidor
            this.eventPromiseError = setTimeout(() => {
                // El sistema ha fallado:
                this.buscando = false
                alert('Ha ocurrido un error. Sin respuesta desde el servidor')
                this.eventPromiseError = null
            }, 60 * 1000); */

            // const cdad = this.buscarComunidad(this.nuevoExpediente.provincia)
            this.buscando = true
            const date = this.fechaObject()

            
            this.nuevoExpediente.ca = this.buscarComunidad(this.nuevoExpediente.provincia)
            this.nuevoExpediente.expediente = `${this.nuevoExpediente.ca.code}${date.formatEUextend}`
            this.nuevoExpediente.fecha = date.formatEU
            this.nuevoExpediente.timeStamp = date.timeStamp
            if (this.nuevoExpediente.refCatastro) {
                this.$store.dispatch('updateCatastroExpediente', this.nuevoExpediente)
            }
            // eventoNewExpediente
            // this.nuevoExpediente.gestor = this.nuevoExpediente.creadoPor = this.gestor
            this.$store.dispatch('newExpediente', this.nuevoExpediente)
            
            this.e1 = 3
            this.buscando = false
            
            /* if (this.alertaCatastroResult) {
                this.expedienteId = this.alertaCatastroResult.expediente
                this.$store.dispatch('newExpediente', this.alertaCatastroResult)
            } */
            // this.e1 = 3
            /* setTimeout(() => {
                this.buscando = false
                this.e1 = 3
            }, 3000) */
        },
        expedienteUpdate() {
            const result = {
                idx: this.nuevoExpediente.expediente,
                data: {
                    admon: this.administrador,
                    gestor: this.gestor
                }
            }
            this.$store.dispatch('updateExpedientes', result)
            this.onFileSubmit()
            this.e1 = 4
        },
        fechaObject(dd = null) {
            let d = new Date()
            if (dd) {
                if (d.getHours() === dd.getHours()) {
                    d = dd
                }
            }
            let dia = `0${d.getUTCDate()}`
            let mes = `0${d.getMonth() + 1}`
            const year = d.getFullYear()
            let hora = `0${d.getHours()}`
            let minuto = `0${d.getMinutes()}`
            let segundo = `0${d.getSeconds()}`

            dia = dia.substr(-2, 2)
            mes = mes.substr(-2, 2)
            hora = hora.substr(-2, 2)
            minuto = minuto.substr(-2, 2)
            segundo = segundo.substr(-2, 2)
            
            const result = {
                formatEU: `${dia}/${mes}/${year}`,
                formatEUextend: `${year}${mes}${dia}${hora}${minuto}${segundo}`,
                timeStamp: d.getTime()
            }

            return result
        }
    }
}
</script>
